"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _carbonComponentsReact = require("carbon-components-react");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ".checkbox {\n  margin-bottom: 1.5rem; }\n  .checkbox > .bx--form-item.bx--checkbox-wrapper {\n    margin: 0; }\n    .checkbox > .bx--form-item.bx--checkbox-wrapper .bx--checkbox-label {\n      padding-left: 18px;\n      padding-top: 5px; }\n    .checkbox > .bx--form-item.bx--checkbox-wrapper .bx--checkbox-label::before {\n      margin: 3px;\n      border-radius: 2px;\n      height: 15px;\n      width: 15px; }\n    .checkbox > .bx--form-item.bx--checkbox-wrapper .bx--checkbox-label::after {\n      left: 0.4rem; }\n    .checkbox > .bx--form-item.bx--checkbox-wrapper .bx--checkbox-label-text {\n      padding-left: 10px; }\n  .checkbox .description {\n    padding-left: 4px; }\n  .checkbox .description::after {\n    display: none !important; }\n  .checkbox .description::before {\n    display: none !important; }\n  .checkbox .error {\n    color: red;\n    font-size: 14px;\n    padding-top: 4px; }\n";
  const fileName = "Checkbox_Checkbox";
  const element = document.querySelector("style[data-sass-component='Checkbox_Checkbox']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const Checkbox = props => {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'checkbox'
  }, props.description && /*#__PURE__*/_react.default.createElement("p", {
    className: "description bx--checkbox-label",
    dangerouslySetInnerHTML: {
      __html: props.description
    }
  }), /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.Checkbox, {
    id: props.id,
    disabled: props.disabled,
    labelText: /*#__PURE__*/_react.default.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: props.label
      }
    }),
    checked: props.value,
    onChange: (value, id, event) => props.onChange(event, value)
  }), props.error && /*#__PURE__*/_react.default.createElement("p", {
    className: "error"
  }, props.error));
};
Checkbox.propTypes = {
  id: _propTypes.default.string.isRequired,
  label: _propTypes.default.string.isRequired,
  value: _propTypes.default.bool.isRequired,
  onChange: _propTypes.default.func.isRequired,
  description: _propTypes.default.string
};
var _default = exports.default = Checkbox;